var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"dropdown-presenter"},_vm._l((_vm.props.data && _vm.props.data.value),function(option){return _c('div',{key:option.label,attrs:{"title":option.label}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }